var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWriteus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_202_26458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6839 8H9.31572C8.43634 8 7.59297 8.39333 6.97115 9.09346C6.34933 9.7936 6 10.7432 6 11.7333V17.0666C6 18.0568 6.34933 19.0063 6.97115 19.7065C7.59297 20.4066 8.43634 20.7999 9.31572 20.7999H18.3913C21.2334 20.7999 23.1281 23.7546 23.1281 23.7759C23.1715 23.8463 23.2297 23.9035 23.2974 23.9425C23.3652 23.9816 23.4404 24.0013 23.5165 23.9999H23.6586C23.7602 23.9667 23.8489 23.8961 23.9107 23.7994C23.9725 23.7028 24.0038 23.5856 23.9996 23.4666V11.7333C23.9996 10.7432 23.6503 9.7936 23.0285 9.09346C22.4067 8.39333 21.5633 8 20.6839 8V8ZM18.2303 13.5573L17.1503 14.7733V14.8266L14.6682 17.6C14.6241 17.6515 14.5711 17.6923 14.5125 17.7198C14.4538 17.7473 14.3907 17.761 14.3272 17.76H12.9914C12.8658 17.76 12.7453 17.7038 12.6565 17.6037C12.5677 17.5037 12.5178 17.3681 12.5178 17.2266V15.6906C12.5168 15.6191 12.529 15.5481 12.5534 15.482C12.5779 15.416 12.6141 15.3563 12.6599 15.3066L15.0945 12.5653H15.1419L16.184 11.3813C16.2741 11.2829 16.3948 11.2279 16.5203 11.2279C16.6459 11.2279 16.7665 11.2829 16.8566 11.3813L18.2303 12.8C18.276 12.8496 18.3123 12.9093 18.3367 12.9754C18.3612 13.0414 18.3733 13.1124 18.3724 13.184C18.3731 13.2539 18.3609 13.3233 18.3364 13.3876C18.3119 13.4519 18.2758 13.5097 18.2303 13.5573V13.5573ZM16.5535 12.4266L17.2261 13.184L16.7903 13.6853L16.1177 12.928L16.5535 12.4266ZM15.4735 13.6853L16.1461 14.4426L14.1661 16.6613H13.4935V15.904L15.4735 13.6853Z",
    fill: "url(#paint0_linear_202_26458)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_202_26458",
    x1: 6.1125,
    y1: 8.32813,
    x2: 26.5073,
    y2: 20.0776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181818"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_202_26458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriteus);
export default __webpack_public_path__ + "static/media/writeus.36f32fadd1a07dc2ac35010036ec1da6.svg";
export { ForwardRef as ReactComponent };